import { applyTheme, useUIStore } from '@store/uiStore';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './app/providers';
import { router } from './app/routes';
import './styles/globals.css';

applyTheme(useUIStore.getState().theme);
useUIStore.subscribe((state) => applyTheme(state.theme));

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');
createRoot(root).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
